import './style.css'
import 'antd/dist/antd.css'
import 'aos/dist/aos.css'
import Gallery from './components/Gallery'
import GallerySerch from './components/Gallery/indexSerch'
import { Serch } from './components/Saerch'
import { Search } from './script/Search'
import { useRecoilState } from 'recoil'
import { ImgData, ImgNameSearch } from '../../state/atom'
import { YearMenu } from './components/YearMenu'
// @ts-ignore
import MetaTags from 'react-meta-tags';
import { ModalComponent } from './components/Modal/Modal'
import ReactGA from 'react-ga'
import { useEffect } from 'react'

function Home() {
  const [Images, setImages] = useRecoilState(ImgData)
  const [text, setText] = useRecoilState(ImgNameSearch)
  useEffect(() => {
    return () => {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }, [])


  if (Search(Images, text)?.length !== 0 && Search(Images, text) !== undefined) {
    return (
      <div className='Gallery'>
        <MetaTags>
          <title>Foto archivio - Ziano</title>
        </MetaTags>
        <YearMenu />
        <GallerySerch Immagini={Search(Images, text)} />
        <Serch />
      </div>
    )
  } else {
    return (
      <div className="Gallery">
        <MetaTags>
          <title>Foto archivio - Ziano</title>
        </MetaTags>
        <ModalComponent/>
        <YearMenu />
        <Gallery Immagini={Images} />
        <Serch />
      </div>
    )
  }
}

export default Home
